import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { Field, Errors } from 'react-redux-form';
import ReactStars from 'react-stars';
import classnames from 'classnames';

class Rating extends Component {
    render() {
        let formRowClassNames = classnames({
            form__row: true,
            'form__row--disabled': this.props.disabled,
            'form__row--error': !this.props.valid && this.props.touched
        });

        return (
            <div>
                <Field
                    model={this.props.model}
                    id={this.props.model}
                    className={formRowClassNames}
                    validators={this.props.validators}
                    mapProps={{ updateOn: props => props.change }}
                >
                    <ReactStars
                        className="form--stars"
                        count={5}
                        half={false}
                        size={24}
                        color1={'#000013'}
                        color2={'#ffd700'}
                    />
                </Field>
                <Errors
                    wrapper={props => (
                        <div className="form__error-messages">
                            {props.children}
                        </div>
                    )}
                    className="errors"
                    model={this.props.model}
                    show="touched"
                    messages={this.props.messages}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, { model }) => ({
    valid: get(state.forms, `${model}.valid`, false),
    touched: get(state.forms, `${model}.touched`, false)
});

export default connect(mapStateToProps)(Rating);



// WEBPACK FOOTER //
// ./src/components/ui/rating.js